'use client';

import affiliateData from '@/data/affiliates.json';
import type { CountryCode } from '@/lib/types';

interface AffiliateProgram {
  name: string;
  url: string;
  description: string;
  category: string;
  icon: string;
}

interface EdTechAffiliateProps {
  countryCode: CountryCode;
  lang?: string;
}

const SECTION_TITLES: Record<string, string> = {
  en: 'Study Resources',
  id: 'Sumber Belajar',
  ms: 'Sumber Pembelajaran',
  tl: 'Mga Mapagkukunan sa Pag-aaral',
};

export function EdTechAffiliate({ countryCode, lang = 'en' }: EdTechAffiliateProps) {
  const programs: AffiliateProgram[] = (affiliateData as Record<string, AffiliateProgram[]>)[countryCode] ?? [];

  if (programs.length === 0) return null;

  return (
    <div className="mt-8">
      <h3 className="text-sm font-semibold text-text-primary md:text-base">
        {SECTION_TITLES[lang] ?? SECTION_TITLES.en}
      </h3>
      <div className="mt-3 grid gap-3 sm:grid-cols-3">
        {programs.map(program => (
          <a
            key={program.name}
            href={program.url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            onClick={() => window._paq?.push(['trackEvent', 'Affiliate', 'Click', program.name])}
            className="flex items-start gap-3 rounded-lg border border-border-subtle p-3 transition-colors hover:border-text-secondary hover:bg-surface-hover"
          >
            <span className="shrink-0 text-xl">{program.icon}</span>
            <div>
              <span className="text-sm font-medium text-text-primary">{program.name}</span>
              <p className="mt-0.5 text-xs text-text-secondary">{program.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
